var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9123 1.67214C39.001 1.45066 39.0227 1.20803 38.9747 0.974332C38.9268 0.740633 38.8113 0.526143 38.6426 0.357452C38.4739 0.188762 38.2594 0.0732886 38.0257 0.0253492C37.792 -0.0225902 37.5494 -0.000887916 37.3279 0.0877656L1.86962 14.2716H1.86718L0.765433 14.7103C0.556759 14.7936 0.375153 14.9329 0.240677 15.1128C0.1062 15.2928 0.0240864 15.5064 0.00340533 15.7302C-0.0172757 15.9539 0.024281 16.1789 0.123485 16.3805C0.222689 16.5821 0.37568 16.7523 0.565558 16.8724L1.56493 17.5061L1.56737 17.511L13.7427 25.2574L21.4891 37.4327L21.4939 37.4376L22.1277 38.437C22.2482 38.6261 22.4185 38.7783 22.6199 38.8769C22.8213 38.9755 23.046 39.0166 23.2693 38.9957C23.4926 38.9748 23.7058 38.8926 23.8854 38.7584C24.065 38.6241 24.2041 38.4429 24.2873 38.2346L38.9123 1.67214ZM34.4444 6.27902L16.1777 24.5456L15.6537 23.7218C15.5577 23.5706 15.4295 23.4424 15.2783 23.3464L14.4544 22.8223L32.7211 4.5557L35.5924 3.40764L34.4468 6.27902H34.4444Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.2c04d63f409699b44a0a973e4d425b54.svg";
export { ForwardRef as ReactComponent };